import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler,
  CountryCityService
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { PersonIdentityDO } from 'app/BaseFramework/shared/models'

@Component({
  selector: 'app-identity-capture',
  templateUrl: './identity-capture.component.html',
  styleUrls: ['./identity-capture.component.scss']
})
export class IdentityCaptureComponent implements OnInit {
  _currentComponentName = 'IdentityCaptureComponent'
  constructor(private viewContainerRef: ViewContainerRef, private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private countryCityService: CountryCityService,
    private msg: NzMessageService) { }

  identityCaptureForm: FormGroup
  IDENTITYCAPTYREFORMNAME = "identityCaptureForm"
  lookupsToBind = ['identityTypeCd']
  selectorOfThisComponent = 'app-identity-capture'
  parentEvent$
  identityList: Array<any> = [];
  item

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
  };

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      let isOutputValid = this.validateOutput(this.identityCaptureForm)
      if (isOutputValid)
        this.EmitComponentOutput(this.identityCaptureForm)
      else {
        this.EmitComponentOutput("ERROR")
      }
    })
  }

  validateOutput(o: FormGroup) {
    this.commonUtilty.markAllFieldDirty(o);
    return o.valid
  }

  //Initializations
  lookup$: any = this.commonUtilty.initializeLookupList(this.lookupsToBind)


  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    this.initializeIdentityForm(this._inputDataForEdit)
    this.subscribeToParentEvent()
    this.initializeIdentityListEditMode()
  }

  initializeIdentityListEditMode() {
    if (this._inputDataForEdit) {
      this.identityList = this._inputDataForEdit;
    }
  }

  /**
   * Form Trasactions
   */

  initializeIdentityForm(data?, isEdit?, index?) {
    let payload = data || {}
    this.identityCaptureForm = this.fb.group({
      identityTypeCd: this.validationUtilService.setValidationsForFormControl('identityTypeCd', this.IDENTITYCAPTYREFORMNAME, payload['identityTypeCd']),
      identityNumber: this.validationUtilService.setValidationsForFormControl('identityNumber', this.IDENTITYCAPTYREFORMNAME, payload['identityNum']),
      isEdit: this.validationUtilService.setValidationsForFormControl('isEdit', this.IDENTITYCAPTYREFORMNAME, isEdit),
      index: this.validationUtilService.setValidationsForFormControl('index', this.IDENTITYCAPTYREFORMNAME, index),
      id: this.validationUtilService.setValidationsForFormControl('id', this.IDENTITYCAPTYREFORMNAME, payload['id']),
    });
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.IDENTITYCAPTYREFORMNAME
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }

  isVerified:boolean=false
  addIdentity() {
    this.msg.loading('Verifying the Data', { nzDuration: 3000 });
    setTimeout(function(){
      this.isVerified=true;      
    }.bind(this),3000);
    if (this.identityCaptureForm.status === 'VALID') {
      let identityDO = new PersonIdentityDO();

      if (this.identityCaptureForm.value.isEdit) {
        identityDO = this.identityList[this.identityCaptureForm.value.index];
      }

      identityDO.identityTypeCd = this.identityCaptureForm.value.identityTypeCd;
      identityDO.identityNum = this.identityCaptureForm.value.identityNumber;


      if (this.identityCaptureForm.value.isEdit) {
        this.identityList.splice(this.identityCaptureForm.value.index, 1, this.commonUtilty.deepCopy(identityDO))
      } else {
        this.identityList.push(this.commonUtilty.deepCopy(identityDO));
      }

      this.EmitComponentOutput(this.identityList)
      this.initializeIdentityForm()
    }
  }

  editIdentity(identity, index) {
    let isEdit = true;
    this.initializeIdentityForm(identity, isEdit, index)
  }

  removeIdentity(identity, index) {
    this.identityList.splice(index, 1);
    this.EmitComponentOutput(this.identityList);
  }
  clearForm() {
    this.initializeIdentityForm()
  }
}
